import React from 'react';

class WorkScheme extends React.Component {
    render(){
        return(
            <section className="schema">
                <div className="container"><h2 className="schema__title">Схема работы</h2>
                    <div className="schema__block">
                        <div className="schema__item"><img className="schema__img" src="images/01.png" alt=""
                                                           role="presentation"/><p className="schema__number">01</p><p
                            className="schema__text">Оператор регистрируется в системе, используя специальное веб-приложение.
                            В этом же веб-приложении отображается необходимая информация по контакту, а также указывается
                            результат обработки.</p></div>
                        <div className="schema__item"><img className="schema__img" src="images/02.png" alt=""
                                                           role="presentation"/><p className="schema__number">02</p><p
                            className="schema__text">При переходе оператора в режим готовности - система дозванивается
                            до респондента и переводит вызов на программный телефон оператора, с одновременным показом
                            данных о контакте.</p></div>
                        <div className="schema__item"><img className="schema__img" src="images/03.png" alt=""
                                                           role="presentation"/><p className="schema__number">03</p><p
                            className="schema__text">Если необходимо, при получении вызова может быть открыта любая ссылка в браузере 
                            с передачей любых параметров идентифицирующих текущий проект и контакт.</p></div>
                        <div className="schema__item"><img className="schema__img" src="images/04.png" alt=""
                                                           role="presentation"/><p className="schema__number">04</p><p
                            className="schema__text">После окончания обработки оператор отмечает результат звонка и
                            сразу (в зависимости от эффективности дозвона) получает следующий вызов для обработки.</p>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default WorkScheme;


// WEBPACK FOOTER //
// ./src/Components/DialerExpress/WorkScheme.js